"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var types_1 = require("../utils/types");
var index_1 = require("../schemas/index");
var constants_1 = require("../utils/constants");
var helper_1 = require("../utils/helper");
var Abi_1 = require("../utils/Abi");
var contractSchemas_1 = require("./contractSchemas");
var contracts_1 = require("./contracts");
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account(web3, apiConfig) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, web3, apiConfig) || this;
        _this.accountProxy = constants_1.NULL_ADDRESS;
        _this.account = apiConfig.account || ((_a = web3.defaultAddress) === null || _a === void 0 ? void 0 : _a.base58) || '';
        if (((_b = _this.account) === null || _b === void 0 ? void 0 : _b.length) > 0)
            _this.account;
        _this.accountProxy = constants_1.NULL_ADDRESS;
        _this.contracts = new contracts_1.Contracts(web3, apiConfig);
        return _this;
    }
    Account.prototype.getTokenApprove = function (paymentToken, basePrice) {
        return __awaiter(this, void 0, void 0, function () {
            var allowance, isApprove, balances;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkTokenTransferProxy(paymentToken.address)];
                    case 1:
                        allowance = _a.sent();
                        isApprove = allowance.gte(basePrice);
                        return [4 /*yield*/, this.getTokenBalances(paymentToken.address)];
                    case 2:
                        balances = _a.sent();
                        return [2 /*return*/, {
                                isApprove: isApprove,
                                balances: balances
                            }];
                }
            });
        });
    };
    Account.prototype.getAssetApprove = function (metadata) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var isApprove, balances, quantity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.checkAssetTransferProxy(metadata)];
                    case 1:
                        isApprove = _b.sent();
                        return [4 /*yield*/, this.getAssetBalances(metadata)];
                    case 2:
                        balances = _b.sent();
                        quantity = ((_a = metadata.asset) === null || _a === void 0 ? void 0 : _a.quantity) || '1';
                        isApprove = isApprove && new constants_1.BigNumber(balances).gte(quantity);
                        return [2 /*return*/, {
                                isApprove: isApprove,
                                balances: balances
                            }];
                }
            });
        });
    };
    Account.prototype.orderApprove = function (_a) {
        var metadata = _a.metadata, paymentToken = _a.paymentToken, side = _a.side, basePrice = _a.basePrice;
        return __awaiter(this, void 0, void 0, function () {
            var sell, assetApprove, _b, isApprove, balances, _c, buy, _d, isApprove, balances;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(side == types_1.OrderSide.Sell)) return [3 /*break*/, 6];
                        sell = {
                            metadata: metadata,
                            paymentTokenApprove: {
                                isApprove: false,
                                func: this.approveTokenTransferProxy,
                                balances: '0'
                            },
                            sellAssetApprove: {
                                isApprove: false,
                                func: this.approveAssetTransferProxy,
                                balances: '0'
                            }
                        };
                        return [4 /*yield*/, this.getAssetApprove(metadata)];
                    case 1:
                        assetApprove = _e.sent();
                        sell.sellAssetApprove.isApprove = assetApprove.isApprove;
                        sell.sellAssetApprove.balances = assetApprove.balances;
                        if (!(paymentToken.address !== constants_1.NULL_ADDRESS)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getTokenApprove(paymentToken, basePrice)];
                    case 2:
                        _b = _e.sent(), isApprove = _b.isApprove, balances = _b.balances;
                        sell.paymentTokenApprove.isApprove = isApprove;
                        sell.paymentTokenApprove.balances = balances;
                        return [3 /*break*/, 5];
                    case 3:
                        sell.paymentTokenApprove.isApprove = true;
                        _c = sell.paymentTokenApprove;
                        return [4 /*yield*/, this.web3.trx.getBalance(this.account)];
                    case 4:
                        _c.balances = _e.sent();
                        _e.label = 5;
                    case 5: return [2 /*return*/, sell];
                    case 6:
                        buy = {
                            paymentTokenApprove: {
                                isApprove: false,
                                balances: '',
                                func: this.approveTokenTransferProxy
                            },
                            metadata: metadata
                        };
                        if (!(paymentToken.address !== constants_1.NULL_ADDRESS)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getTokenApprove(paymentToken, basePrice)];
                    case 7:
                        _d = _e.sent(), isApprove = _d.isApprove, balances = _d.balances;
                        buy.paymentTokenApprove.isApprove = isApprove;
                        buy.paymentTokenApprove.balances = balances;
                        return [3 /*break*/, 9];
                    case 8: throw "Error";
                    case 9: return [2 /*return*/, buy];
                }
            });
        });
    };
    Account.prototype.getOrderApproveStep = function (params, side, startAmount) {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, paymentToken, decimals, basePrice;
            return __generator(this, function (_a) {
                metadata = (0, helper_1.assetToMetadata)(params.asset, params.quantity ? String(params.quantity) : '1');
                paymentToken = params.paymentToken || this.TRX;
                decimals = new constants_1.BigNumber(10).pow(paymentToken.decimals);
                basePrice = new constants_1.BigNumber(startAmount).times(decimals);
                return [2 /*return*/, this.orderApprove({
                        metadata: metadata,
                        paymentToken: paymentToken,
                        side: side,
                        basePrice: basePrice
                    })];
            });
        });
    };
    Account.prototype.orderApproveCalldata = function (_a) {
        var metadata = _a.metadata, paymentToken = _a.paymentToken, side = _a.side, basePrice = _a.basePrice;
        return __awaiter(this, void 0, void 0, function () {
            var proxy, sell, assetApprove, _b, isApprove, balances, _c, buy, _d, isApprove, balances;
            var _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(side == types_1.OrderSide.Sell)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getAccountProxy(metadata.schema)];
                    case 1:
                        proxy = _g.sent();
                        _e = {
                            metadata: metadata,
                            paymentTokenApprove: {
                                isApprove: false,
                                calldata: this.approveTokenTransferProxyCalldata(paymentToken.address),
                                balances: '0'
                            }
                        };
                        _f = {
                            isApprove: false
                        };
                        return [4 /*yield*/, this.approveAssetTransferProxyCalldata(metadata, proxy)];
                    case 2:
                        sell = (_e.sellAssetApprove = (_f.calldata = _g.sent(),
                            _f.balances = '0',
                            _f),
                            _e);
                        return [4 /*yield*/, this.getAssetApprove(metadata)];
                    case 3:
                        assetApprove = _g.sent();
                        sell.sellAssetApprove.isApprove = assetApprove.isApprove;
                        sell.sellAssetApprove.balances = assetApprove.balances;
                        if (!(paymentToken.address !== constants_1.NULL_ADDRESS)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getTokenApprove(paymentToken, basePrice)];
                    case 4:
                        _b = _g.sent(), isApprove = _b.isApprove, balances = _b.balances;
                        sell.paymentTokenApprove.isApprove = isApprove;
                        sell.paymentTokenApprove.balances = balances;
                        return [3 /*break*/, 7];
                    case 5:
                        sell.paymentTokenApprove.isApprove = true;
                        _c = sell.paymentTokenApprove;
                        return [4 /*yield*/, this.web3.trx.getBalance(this.account)];
                    case 6:
                        _c.balances = _g.sent();
                        _g.label = 7;
                    case 7: return [2 /*return*/, sell];
                    case 8:
                        buy = {
                            paymentTokenApprove: {
                                isApprove: false,
                                balances: '',
                                calldata: this.approveTokenTransferProxyCalldata(paymentToken.address)
                            },
                            metadata: metadata
                        };
                        if (!(paymentToken.address !== constants_1.NULL_ADDRESS)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.getTokenApprove(paymentToken, basePrice)];
                    case 9:
                        _d = _g.sent(), isApprove = _d.isApprove, balances = _d.balances;
                        buy.paymentTokenApprove.isApprove = isApprove;
                        buy.paymentTokenApprove.balances = balances;
                        return [3 /*break*/, 11];
                    case 10: throw "Error";
                    case 11: return [2 /*return*/, buy];
                }
            });
        });
    };
    Account.prototype.getAccountProxy = function (schemaName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (schemaName === types_1.APENFTSchemaName.ERC1155) {
                    return [2 /*return*/, Promise.resolve(this.erc1155AssetProxy)];
                }
                return [2 /*return*/, Promise.resolve(this.erc721AssetProxy)];
            });
        });
    };
    Account.prototype.checkTokenTransferProxy = function (to) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenProxy, accountApprove, data, params, rawData, callData;
            return __generator(this, function (_a) {
                tokenProxy = this.erc20AssetProxy;
                accountApprove = this.Erc20Func.isApprove({ address: to });
                data = (0, index_1.encodeParamsCall)(accountApprove, { owner: this.account, replace: tokenProxy });
                params = (0, index_1.getParams)(accountApprove, { owner: this.account, replace: tokenProxy });
                rawData = {
                    functionSelector: Abi_1.ABI.methodSig(accountApprove),
                    parameters: Abi_1.ABI.paramsArray(accountApprove.inputs, params)
                };
                callData = { to: to, data: data, rawData: rawData };
                return [2 /*return*/, this.tronCall(callData, accountApprove === null || accountApprove === void 0 ? void 0 : accountApprove.outputs)];
            });
        });
    };
    Account.prototype.getTokenBalances = function (to, account) {
        return __awaiter(this, void 0, void 0, function () {
            var owner, accountBal, data, params, rawData, callData, b;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        owner = account || this.account;
                        accountBal = this.Erc20Func.countOf({ address: to });
                        data = (0, index_1.encodeParamsCall)(accountBal, { owner: owner });
                        params = (0, index_1.getParams)(accountBal, { owner: owner });
                        rawData = {
                            functionSelector: Abi_1.ABI.methodSig(accountBal),
                            parameters: Abi_1.ABI.paramsArray(accountBal.inputs, params)
                        };
                        callData = { to: to, data: data, rawData: rawData };
                        return [4 /*yield*/, this.tronCall(callData, accountBal === null || accountBal === void 0 ? void 0 : accountBal.outputs)];
                    case 1:
                        b = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve) { return resolve(b.toString()); })];
                }
            });
        });
    };
    Account.prototype.getAssetBalances = function (metadata, account) {
        return __awaiter(this, void 0, void 0, function () {
            var owner, accountBal, data, params, rawData, callData, bal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        owner = account || this.account;
                        accountBal = (0, index_1.getBalanceSchemas)(metadata);
                        data = (0, index_1.encodeParamsCall)(accountBal, { owner: owner });
                        params = (0, index_1.getParams)(accountBal, { owner: owner });
                        rawData = {
                            functionSelector: Abi_1.ABI.methodSig(accountBal),
                            parameters: Abi_1.ABI.paramsArray(accountBal.inputs, params)
                        };
                        callData = { to: accountBal.target, data: data, rawData: rawData };
                        return [4 /*yield*/, this.tronCall(callData, accountBal === null || accountBal === void 0 ? void 0 : accountBal.outputs)];
                    case 1:
                        bal = _a.sent();
                        if ((accountBal === null || accountBal === void 0 ? void 0 : accountBal.outputs[0].type) === 'address') {
                            return [2 /*return*/, this.web3.address.fromHex(bal) === owner ? '1' : '0'];
                        }
                        else {
                            return [2 /*return*/, bal.toString()];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Account.prototype.approveTokenTransferProxy = function (tokenAddr) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenProxy, quantity, accountApprove, data, params, rawData, callData;
            return __generator(this, function (_a) {
                tokenProxy = this.erc20AssetProxy;
                quantity = constants_1.MAX_UINT_256.toString();
                accountApprove = this.Erc20Func.approve({ quantity: quantity });
                data = (0, index_1.encodeParamsCall)(accountApprove, { replace: tokenProxy });
                params = (0, index_1.getParams)(accountApprove, { replace: tokenProxy });
                rawData = {
                    functionSelector: Abi_1.ABI.methodSig(accountApprove),
                    parameters: Abi_1.ABI.paramsArray(accountApprove.inputs, params)
                };
                callData = { to: tokenAddr, data: data, rawData: rawData };
                return [2 /*return*/, this.tronSend(callData, this.account)];
            });
        });
    };
    Account.prototype.approveTokenTransferProxyCalldata = function (tokenAddr) {
        var tokenProxy = this.erc20AssetProxy;
        var quantity = constants_1.MAX_UINT_256.toString();
        var accountApprove = this.Erc20Func.approve({ quantity: quantity });
        var data = (0, index_1.encodeParamsCall)(accountApprove, { replace: tokenProxy });
        return { to: tokenAddr, data: data };
    };
    Account.prototype.checkAssetTransferProxy = function (metadata) {
        return __awaiter(this, void 0, void 0, function () {
            var owner, operator, accountApprove, data, params, rawData, callData, res, isAddr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        owner = this.account;
                        return [4 /*yield*/, this.getAccountProxy(metadata.schema)];
                    case 1:
                        operator = _a.sent();
                        accountApprove = (0, index_1.getIsApproveSchemas)(metadata);
                        data = (0, index_1.encodeParamsCall)(accountApprove, { owner: owner, replace: operator });
                        params = (0, index_1.getParams)(accountApprove, { owner: owner, replace: operator });
                        rawData = {
                            functionSelector: Abi_1.ABI.methodSig(accountApprove),
                            parameters: Abi_1.ABI.paramsArray(accountApprove.inputs, params)
                        };
                        callData = { to: accountApprove.target, data: data, rawData: rawData };
                        return [4 /*yield*/, this.tronCall(callData, accountApprove === null || accountApprove === void 0 ? void 0 : accountApprove.outputs)];
                    case 2:
                        res = _a.sent();
                        isAddr = accountApprove === null || accountApprove === void 0 ? void 0 : accountApprove.outputs.some(function (val) { return val.type == 'address'; });
                        if (isAddr) {
                            return [2 /*return*/, this.web3.address.fromHex(res) === operator];
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    Account.prototype.approveAssetTransferProxy = function (metadata) {
        return __awaiter(this, void 0, void 0, function () {
            var operator, accountApprove, data, params, rawData, callData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccountProxy(metadata.schema)];
                    case 1:
                        operator = _a.sent();
                        accountApprove = (0, index_1.getApproveSchemas)(metadata);
                        data = (0, index_1.encodeParamsCall)(accountApprove, { owner: operator, replace: true });
                        params = (0, index_1.getParams)(accountApprove, { owner: operator, replace: true });
                        rawData = {
                            functionSelector: Abi_1.ABI.methodSig(accountApprove),
                            parameters: Abi_1.ABI.paramsArray(accountApprove.inputs, params)
                        };
                        callData = { to: accountApprove.target, data: data, rawData: rawData };
                        return [2 /*return*/, this.tronSend(callData, this.account)];
                }
            });
        });
    };
    Account.prototype.approveAssetTransferProxyCalldata = function (metadata, operator) {
        var accountApprove = (0, index_1.getApproveSchemas)(metadata);
        var data = (0, index_1.encodeParamsCall)(accountApprove, { owner: operator, replace: true });
        return { to: accountApprove.target, data: data };
    };
    Account.prototype.orderMatch = function (_a) {
        var buy = _a.buy, sell = _a.sell, _b = _a.metadata, metadata = _b === void 0 ? '0x0000000000000000000000000000000000000000000000000000000000000000' : _b;
        return __awaiter(this, void 0, void 0, function () {
            var sellOrderParamArray, sellOrderSigArray, buyOrderParamArray, buyOrderSigArray, params, value, to, exchangeFunc, data, rawData, callData;
            return __generator(this, function (_c) {
                sellOrderParamArray = (0, helper_1.orderParamsEncode)(sell);
                sellOrderSigArray = (0, helper_1.orderSigEncode)(sell);
                buyOrderParamArray = (0, helper_1.orderParamsEncode)(buy);
                buyOrderSigArray = (0, helper_1.orderSigEncode)(buy);
                params = [buyOrderParamArray, buyOrderSigArray, sellOrderParamArray, sellOrderSigArray, metadata];
                value = buy.paymentToken == constants_1.NULL_ADDRESS ? buy.basePrice : 0;
                to = this.APENFTExchange;
                exchangeFunc = this.APENFTExchangeFunc.orderMatch({
                    address: to
                });
                data = (0, index_1.encodeWeb3Call)(exchangeFunc, params);
                rawData = {
                    functionSelector: Abi_1.ABI.methodSig(exchangeFunc),
                    parameters: Abi_1.ABI.paramsArray(exchangeFunc.inputs, params)
                };
                callData = { to: to, data: data, value: value, rawData: rawData };
                return [2 /*return*/, this.tronSend(callData, this.account)];
            });
        });
    };
    Account.prototype.orderCancel = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var to, orderParamArray, orderSigArray, exchangeFunc, params, data, rawData, callData;
            return __generator(this, function (_a) {
                to = this.APENFTExchange;
                orderParamArray = (0, helper_1.orderParamsEncode)(order);
                orderSigArray = (0, helper_1.orderSigEncode)(order);
                exchangeFunc = this.APENFTExchangeFunc.orderCancel({
                    address: to
                });
                params = [orderParamArray, orderSigArray];
                data = (0, index_1.encodeWeb3Call)(exchangeFunc, params);
                rawData = {
                    functionSelector: Abi_1.ABI.methodSig(exchangeFunc),
                    parameters: Abi_1.ABI.paramsArray(exchangeFunc.inputs, params)
                };
                callData = { to: to, data: data, rawData: rawData };
                return [2 /*return*/, this.tronSend(callData, this.account)];
            });
        });
    };
    Account.prototype.assetTransfer = function (metadata, to) {
        return __awaiter(this, void 0, void 0, function () {
            var owner, accountApprove, data, params, rawData, callData;
            return __generator(this, function (_a) {
                owner = this.account;
                accountApprove = (0, index_1.getTransferSchemas)(metadata);
                data = (0, index_1.encodeParamsCall)(accountApprove, { owner: owner, replace: to });
                params = (0, index_1.getParams)(accountApprove, { owner: owner, replace: to });
                rawData = {
                    functionSelector: Abi_1.ABI.methodSig(accountApprove),
                    parameters: Abi_1.ABI.paramsArray(accountApprove.inputs, params)
                };
                callData = { to: accountApprove.target, data: data, rawData: rawData };
                return [2 /*return*/, this.tronSend(callData, owner)];
            });
        });
    };
    Account.prototype.accountApprove = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = String(error.code);
                        switch (_a) {
                            case '1101': return [3 /*break*/, 1];
                            case '1102': return [3 /*break*/, 3];
                            case '1106': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.approveTokenTransferProxy(error.data.erc20Address)];
                    case 2: // erc20 token
                    return [2 /*return*/, _b.sent()];
                    case 3: return [4 /*yield*/, this.approveAssetTransferProxy(error.data.order.metadata)];
                    case 4: // checkApproveERC1155TransferProxy
                    return [2 /*return*/, _b.sent()];
                    case 5: return [4 /*yield*/, this.approveAssetTransferProxy(error.data.order.metadata)];
                    case 6: // checkApproveERC721TransferProxy
                    return [2 /*return*/, _b.sent()];
                    case 7: throw error;
                }
            });
        });
    };
    return Account;
}(contractSchemas_1.ContractSchemas));
exports.Account = Account;
